import axios from "./axiosinstance";

const FollowupApi = {
  add: (payload) => axios.post("followUps/add", payload),
  list: (leadId) => axios.get(`followUps/list/${leadId}`),
  status: () => axios.get("followUps/status"),
  getByDate: (range) => axios.get(`followUps/by-date?range=${range}`),
};

export default FollowupApi;